import {
  HideableSectionWithPermission,
  VehicleSpecsSection,
} from '@ltvco/refresh-lib/v2';
import { Text } from '@ltvco/refresh-lib/theme';
import { SerializedVehicleReport, vehiclesTypes } from '@ltvco/refresh-lib/v1';

interface TeaserVehicleReportProps {
  vehicleSpecs: vehiclesTypes.VehicleReportVehicleSpecs;
  reportData: SerializedVehicleReport;
  isTeaserReport: boolean;
}

export const TeaserVehicleReport = ({
  vehicleSpecs,
  reportData,
  isTeaserReport,
}: TeaserVehicleReportProps) => {
  return (
    <>
      {/* Vehicle History Section */}
      <HideableSectionWithPermission
        nameToDisplay="Vehicle History"
        nameToRecord="vehicle_history"
        id="vehicle-history"
        isParentSection
        accidentsCount={reportData?.automobiles?.[0]?.accidentsCount ?? 0}
      >
        <Text variant="h4">Vehicle History</Text>
      </HideableSectionWithPermission>

      <HideableSectionWithPermission
        nameToDisplay="Specs"
        nameToRecord="specifications"
        id="vehicle-specs"
      >
        <VehicleSpecsSection
          vehicleSpecs={vehicleSpecs}
          vehicleDesign={reportData?.automobiles?.[0]?.design}
          firstVehicleImage={reportData?.automobiles?.[0]?.images?.[0]}
        />
      </HideableSectionWithPermission>

      {/* Maintenance & Repairs Section */}
      <HideableSectionWithPermission
        nameToDisplay="Maintenance & Repairs"
        nameToRecord="maintenance_repairs"
        id="maintenance-repairs"
        isParentSection
        isTeaserReport={isTeaserReport}
      >
        <Text variant="h4">Maintenance & Repairs</Text>
      </HideableSectionWithPermission>

      {/* Market Value Section */}
      <HideableSectionWithPermission
        nameToDisplay="Market Value"
        nameToRecord="market_value"
        id="market-value"
        isParentSection
        isTeaserReport={isTeaserReport}
      >
        <Text variant="h4">Market Value</Text>
      </HideableSectionWithPermission>

      {/* Additional Info Section */}
      <HideableSectionWithPermission
        nameToDisplay="Additional Info"
        nameToRecord="additional_info"
        id="additional-info"
        isParentSection
        isTeaserReport={isTeaserReport}
      >
        <Text variant="h4">Additional Info</Text>
      </HideableSectionWithPermission>
    </>
  );
};
